import Logo from "../../assets/icon/logo.svg";
import Triangle from "../../assets/icon/triangle.svg";

import { useUser } from "../../contexts/userContext";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { useJwt } from "../../contexts/jwtContext";

const Header = () => {
  const { user, setUser } = useUser();
  const [showMenu, setShowMenu] = useState(false);
  const { setJwt } = useJwt();

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const logOut = () => {
    setJwt("");
    setUser(null);
    window.sessionStorage.clear();
  };

  useEffect(() => {
    try {
      setUser(JSON.parse(window.sessionStorage.user));
    } catch (err) {
      logOut();
    }
  }, []);

  return (
    <div className="grid grid-cols-[7rem_min-content_1fr] items-center border-b-2 border-border-gray py-4 w-screen h-32">
      <img
        src={Logo}
        className="justify-self-center h-16 drop-shadow-[0_2px_4px_rgba(0,0,0,0.2)]"
        alt="logo"
      />
      <h1 className="text-6xl font-chinese font-medium text-title whitespace-nowrap ">
        {process.env.REACT_APP_TITLE}
      </h1>
      <div className="w-24 h-24 justify-self-end mr-20 flex items-end">
        <div className="flex items-center">
          <img
            src={Triangle}
            onClick={toggleMenu}
            className={`w-4 h-4 ${showMenu ? "rotate-180" : "rotate-90"} transition cursor-pointer hover:brightness-50`}
            alt="toggle account option"
          />
          <p className="text-custom-gray  text-xl ml-2 font-bold whitespace-nowrap">
            {user?.displayName ?? "載入中..."}
          </p>
          {showMenu ? (
            <div className="border-2 border-border-gray absolute border-t-0 bg-white top-32 grid grid-rows-2 justify-items-start">
              <Link
                to="/update-password"
                className="p-2 pr-8  text-custom-gray font-bold border-b-2 border-dashed border-border-gray text-xl font-chinese hover:brightness-75"
              >
                修改密碼
              </Link>
              <button
                onClick={logOut}
                className="p-2 pr-8 text-custom-gray font-semibold text-xl font-chinese hover:brightness-75"
              >
                登出
              </button>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
